import { render, staticRenderFns } from "./tagShow.vue?vue&type=template&id=396dcff1&scoped=true&"
import script from "./tagShow.vue?vue&type=script&lang=js&"
export * from "./tagShow.vue?vue&type=script&lang=js&"
import style0 from "./tagShow.vue?vue&type=style&index=0&id=396dcff1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "396dcff1",
  null
  
)

export default component.exports